import React from 'react';
import PropTypes from 'prop-types';

const FolderIcon = ({ size = '32px', fill = '#91a2b9' }) => {
  return (
    <svg version="1.1" width={size} height={size} >
      <g transform="matrix(1 0 0 1 -10 -581 )">
        <path d="M 21.1274038461538 4.34517045454545  C 21.7091346153846 4.93892045454545  22 5.64962121212121  22 6.47727272727273  L 22 15.9772727272727  C 22 16.8049242424242  21.7091346153846 17.515625  21.1274038461538 18.109375  C 20.5456730769231 18.703125  19.849358974359 19  19.0384615384615 19  L 2.96153846153846 19  C 2.15064102564103 19  1.45432692307692 18.703125  0.872596153846154 18.109375  C 0.290865384615385 17.515625  0 16.8049242424242  0 15.9772727272727  L 0 3.02272727272727  C 0 2.19507575757575  0.290865384615385 1.484375  0.872596153846154 0.890625  C 1.45432692307692 0.296875  2.15064102564103 0  2.96153846153846 0  L 7.19230769230769 0  C 8.00320512820513 0  8.69951923076923 0.296875  9.28125 0.890625  C 9.86298076923077 1.484375  10.1538461538462 2.19507575757575  10.1538461538462 3.02272727272727  L 10.1538461538462 3.45454545454545  L 19.0384615384615 3.45454545454545  C 19.849358974359 3.45454545454545  20.5456730769231 3.75142045454545  21.1274038461538 4.34517045454545  Z " fillRule="nonzero" fill={fill} stroke="none" transform="matrix(1 0 0 1 10 581 )" />
      </g>
    </svg>
  );
};

FolderIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

export default FolderIcon;
